module.exports = __webpack_public_path__ + "img/matana_yes.a50024b0.png";